module.exports = __webpack_public_path__ + "static/img/PortfoliosmithLogo.e9a4240.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/PortfoliosmithLogo.svg
// module id = TjgY
// module chunks = 1